import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Ng2StateDeclaration, UIRouterModule } from '@uirouter/angular';
import { JobProfilePageComponent } from './job-profile-page.component';
import { JobProfileModule } from './job-profile/job-profile.module';

const states: Ng2StateDeclaration[] = [
  {
    name: 'missioncontrol.jobprofile',
    url: '/jobprofile',
    component: JobProfilePageComponent,
    data: {
      requireLogin: true
    },
    params: {
      jobId: null
    }
  }
];

@NgModule({
  declarations: [JobProfilePageComponent],
  imports: [
    CommonModule,
    JobProfileModule,
    UIRouterModule.forChild({ states })
  ],
  exports: [JobProfilePageComponent],
  entryComponents: [JobProfilePageComponent]
})
export class JobProfilePageModule { }
